<template>
    <div class="quote__form">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="bg">
                        <div class="title">
                            {{ $t("promo.Your Quote is ready!") }}
                        </div>
                        <div class="bullet-list-container position-relative">
                            <img
                                v-if="options.panel_type === 'glass-glass'"
                                class="panel"
                                srcset="/images/promo/gg@2x.png 2x"
                                src="/images/promo/gg.png"
                                width="84"
                                height="144"
                            />
                            <img
                                v-else
                                class="panel"
                                srcset="/images/promo/gf@2x.png 2x"
                                src="/images/promo/gf.png"
                                width="84"
                                height="144"
                            />
                            <img
                                class="inverter"
                                srcset="/images/promo/sma@2x.png 2x"
                                src="/images/promo/sma.png"
                                width="42"
                                height="54"
                            />
                            <ul>
                                <li class="my-0 my-md-1">
                                    <img
                                        src="/images/promo/bullet.svg"
                                        alt=""
                                    />
                                    <span
                                        v-if="
                                            options.panel_type === 'glass-foil'
                                        "
                                        v-html="
                                            $t('promo.results-bullet-1-foil', {
                                                value: options.panels_number,
                                            })
                                        "
                                    >
                                    </span>
                                    <span
                                        v-else
                                        v-html="
                                            $t('promo.results-bullet-1-glass', {
                                                value: options.panels_number,
                                            })
                                        "
                                    >
                                    </span>
                                </li>
                                <!--                <li class="my-0 my-md-1">-->
                                <!--                  <img src="/images/promo/bullet.svg" alt=""/>-->
                                <!--                  <span v-html="$t('promo.results-bullet-2')"> </span>-->
                                <!--                </li>-->
                                <li class="my-0 my-md-1">
                                    <img
                                        src="/images/promo/bullet.svg"
                                        alt=""
                                    />
                                    <span
                                        v-html="$t('promo.results-bullet-3', {value: maxKwhOutput})"
                                    >
                                    </span>
                                </li>
                                <li class="my-0 my-md-1">
                                    <img
                                        src="/images/promo/bullet.svg"
                                        alt=""
                                    />
                                    <span
                                        v-html="
                                            $t('promo.results-bullet-4', {
                                                value: allDiscounts,
                                            })
                                        "
                                    >
                                    </span>
                                </li>
                                <li class="my-0 my-md-1">
                                    <img
                                        src="/images/promo/bullet.svg"
                                        alt=""
                                    />
                                    <span
                                        v-html="
                                            $t('promo.results-bullet-5', {
                                                value: paybackPeriod,
                                            })
                                        "
                                    >
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <!--            <p v-html="$t('promo.Quote details', {-->
                        <!--              '0':installationSize,-->
                        <!--              '1':minKwhOutput,-->
                        <!--              '2':maxKwhOutput,-->
                        <!--              '3':newEnergyBIll,-->
                        <!--              '4':paybackPeriod-->
                        <!--            })"></p>-->
                        <div class="form-hodler" :class="{ opened: openModal }">
                            <form action="">
                                <span class="close" @click="openModal = false">
                                    <img
                                        src="/images/promo/form-close.svg"
                                        alt=""
                                    />
                                </span>
                                <template v-if="!showThankYouModal">
                                    <div
                                        class="form__step"
                                        :class="{
                                            current: form_step == 1,
                                            animate: animate,
                                        }"
                                    >
                                        <div class="form-title">
                                            {{ $t("promo.Send me my quote") }}
                                        </div>
                                        <div
                                            class="d-flex flex-wrap justify-content-between"
                                        >
                                            <div class="field">
                                                <input
                                                    type="text"
                                                    v-model="form.first_name"
                                                    :placeholder="
                                                        $t('promo.First name')
                                                    "
                                                    :class="{
                                                        error: !valid.first_name,
                                                    }"
                                                />
                                            </div>
                                            <!--                      <div class="field ">-->
                                            <!--                        <input-->
                                            <!--                          type="text"-->
                                            <!--                          v-model="form.last_name"-->
                                            <!--                          :placeholder="$t('promo.Last name')"-->
                                            <!--                          :class="{ error: !valid.last_name }"-->
                                            <!--                        />-->
                                            <!--                      </div>-->
                                            <div class="field">
                                                <input
                                                    type="email"
                                                    v-model="form.email"
                                                    :placeholder="
                                                        $t('promo.Email')
                                                    "
                                                    :class="{
                                                        error: !valid.email,
                                                    }"
                                                />
                                            </div>
                                            <div class="field">
                                                <input
                                                    type="tel"
                                                    v-model="form.phone"
                                                    :placeholder="
                                                        $t('promo.Phone number')
                                                    "
                                                    :class="{
                                                        error: !valid.phone,
                                                    }"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="form__step"
                                        :class="{
                                            current: form_step == 2,
                                            animate: animate,
                                        }"
                                    >
                                        <div class="form-title">
                                            {{
                                                $t("promo.Installation address")
                                            }}
                                            <!--                      <a href="#">(why wee need this)</a>-->
                                        </div>
                                        <div
                                            class="d-flex flex-wrap justify-content-between"
                                        >
                                            <div class="field street_name">
                                                <input
                                                    type="text"
                                                    v-model="
                                                        form
                                                            .installation_address
                                                            .street_name
                                                    "
                                                    :placeholder="
                                                        $t('promo.Street')
                                                    "
                                                    :class="{
                                                        error: !valid
                                                            .installation_address
                                                            .street_name,
                                                    }"
                                                />
                                            </div>
                                            <div class="field street_number">
                                                <input
                                                    type="text"
                                                    v-model="
                                                        form
                                                            .installation_address
                                                            .street_number
                                                    "
                                                    :placeholder="
                                                        $t('promo.Number')
                                                    "
                                                    :class="{
                                                        error: !valid
                                                            .installation_address
                                                            .street_number,
                                                    }"
                                                />
                                            </div>
                                            <div class="field zip">
                                                <input
                                                    type="email"
                                                    v-model="
                                                        form
                                                            .installation_address
                                                            .zip_code
                                                    "
                                                    :placeholder="
                                                        $t('promo.Zip')
                                                    "
                                                    :class="{
                                                        error: !valid
                                                            .installation_address
                                                            .zip_code,
                                                    }"
                                                />
                                            </div>
                                            <div class="field city">
                                                <input
                                                    type="text"
                                                    v-model="
                                                        form
                                                            .installation_address
                                                            .city
                                                    "
                                                    :placeholder="
                                                        $t('promo.City')
                                                    "
                                                    :class="{
                                                        error: !valid
                                                            .installation_address
                                                            .city,
                                                    }"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="field w-100 w-lg-50">
                                            <button
                                                class="btn btn-primary"
                                                @click.prevent="nextStep"
                                            >
                                                {{ $t("promo.Send my quote") }}
                                                <img
                                                    src="/images/promo/arrow-right.svg"
                                                    alt=""
                                                />
                                            </button>
                                        </div>
                                        <!--                    <div class="field text-center d-none d-lg-flex">-->
                                        <!--                      <a href="#">{{ $t('promo.What happens next?') }}</a>-->
                                        <!--                    </div>-->
                                    </div>
                                </template>
                                <template v-else>
                                    <thank-you />
                                </template>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6"></div>
            </div>
        </div>
    </div>
</template>

<script>
import ThankYou from "@/Components/Promo/ThankYou";
import InfoTooltip from "@/Components/Promo/InfoTooltip";
import { mapGetters } from "vuex";

export default {
    components: { ThankYou, InfoTooltip },
    data() {
        return {
            openModal: false,
            form_step: 1,
            animate: true,
            showThankYouModal: false,
            valid: {
                first_name: true,
                // last_name: true,
                email: true,
                phone: true,
                installation_address: {
                    street_name: true,
                    street_number: true,
                    zip_code: true,
                    city: true,
                },
            },
            form: {
                first_name: "",
                // last_name: "",
                email: "",
                phone: "",
                installation_address: {
                    street_name: "",
                    street_number: "",
                    zip_code: "",
                    city: "",
                },
            },
        };
    },
    watch: {
        form_step: function () {
            setTimeout(() => {
                this.animate = true;
            }, 200);
        },
    },
    computed: {
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
        minKwhOutput() {
            return Math.round(this.installationSize * 0.9 * 1000);
        },
        maxKwhOutput() {
            return Math.round(this.installationSize * 1.1 * 1000);
        },
        newEnergyBIll() {
            return "25";
        },
        paybackPeriod() {
            if (this.locale === "pl") {
                return (
                    Math.round(
                        (((this.price * 0.92 - 3000) * 0.83) /
                            (this.monthly_payment * 12)) *
                            100
                    ) / 100
                );
            }
            return (
                Math.round(
                    ((this.price * 0.9) / (this.monthly_payment * 12)) * 100
                ) / 100
            );
        },
        allDiscounts() {
            if (this.locale === "pl") {
                let discountPercentage = 8;
                let discount = this.price * 0.1;
                let mp = 3000;
                let tax =
                    ((this.price - discount) * (1 - discountPercentage / 100) -
                        3000) *
                    0.17;
                return Math.round(discount + mp + tax);
            }
        },
        ...mapGetters({
            options: "options",
            monthly_payment: "monthly_payment",
            roof_type: "roof_type",
            price: "price",
            base_price: "base_price",
            annualConsumption: "annual_consumption",
            installationSize: "installation_size",
        }),
    },
    mounted() {},
    methods: {
        submitForm() {
            this.$inertia.post(this.route("promo-quote-submit"), {
                ...this.form,
                ...this.options,
                ...this.monthly_payment,
                roof_type: this.roof_type,
                price: this.price,
                base_price: this.base_price,
            });
            this.showThankYou();
        },
        showThankYou() {
            if (Number(window.innerWidth) <= 991) {
                this.showThankYouModal = true;
            } else {
                this.$emit("formSent", true);
                this.openModal = false;
            }
        },
        validateEmail() {
            var email = this.form.email;
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validateStepOne() {
            var valid = true;
            var form = this.form;
            if (!form.first_name) {
                valid = false;
                this.valid.first_name = false;
            }
            // if (!form.last_name) {
            //   valid = false;
            //   this.valid.last_name = false;
            // }
            if (!form.email || !this.validateEmail()) {
                valid = false;
                this.valid.email = false;
            }
            if (!form.phone) {
                valid = false;
                this.valid.phone = false;
            }

            return valid;
        },
        validateStepTwo() {
            var valid = true;
            var form = this.form.installation_address;
            if (!form.street_name) {
                valid = false;
                this.valid.installation_address.street_name = false;
            }
            if (!form.street_number) {
                valid = false;
                this.valid.installation_address.street_number = false;
            }
            if (!form.zip_code) {
                valid = false;
                this.valid.installation_address.zip_code = false;
            }
            if (!form.city) {
                valid = false;
                this.valid.installation_address.city = false;
            }
            return valid;
        },
        nextStep() {
            if (this.form_step == 1) {
                var valid = this.validateStepOne();
                if (valid) {
                    this.animate = false;
                    this.submitForm();
                    this.form_step += 2;
                }
            }
            // else {
            //   var addressValid = this.validateStepTwo();
            //   if (addressValid) {
            //     this.submitForm();
            //   }
            // }
        },
    },
};
</script>

<style lang="scss" scoped>
.quote {
    .bullet-list-container {
        > img {
            position: absolute;
            &.panel {
                right: 0;
                bottom: -40px;
                @media (max-width: 700px) {
                    bottom: -20px;
                }
            }
            &.inverter {
                bottom: -37px;
                right: 61px;
                @media (max-width: 700px) {
                    bottom: -17px;
                }
            }
        }

        @media (max-width: 700px) {
            margin: 8px 0;
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                font-weight: normal;
                font-size: 16px;
                line-height: 30px;
                color: #1b2f51;
                position: relative;
                padding-left: 24px;

                img {
                    position: absolute;
                    left: 0;
                    top: 7px;
                }
            }
        }
    }

    &__form {
        margin-top: 32px;
        @media (max-width: 991px) {
            margin-top: 14px;
        }

        &.light {
            .bg {
                .title {
                    @media (max-width: 991px) {
                        display: none;
                    }
                }
            }
        }

        .form-hodler {
            @media (max-width: 991px) {
                position: fixed;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background: rgba(20, 20, 48, 0.8);
                z-index: 100;
                align-items: center;
                overflow-y: scroll;
                justify-content: center;
                display: none;
                &.opened {
                    display: flex;
                }
            }
        }

        .bg {
            padding: 18px;
            background: #f7f9fc;
            border-radius: 8px;

            &:not(.light) {
                strong {
                    font-weight: normal;
                }

                @media (max-width: 991px) {
                    //border-bottom: 1px solid #cfd6ea;
                    padding: 0;
                    background: none;
                }
            }

            .title {
                font-weight: 600;
                font-size: 32px;
                color: #2c2c4f;
                @media (max-width: 991px) {
                    font-weight: 600;
                    font-size: 18px;
                }
            }

            p {
                font-size: 15px;
                line-height: 24px;
                color: #1b2f51;
                @media (max-width: 991px) {
                    font-size: 16px;
                    color: #1b2f51;
                }
            }

            form {
                position: relative;

                .form__step {
                    display: none;

                    &.current {
                        display: block;
                        opacity: 0;
                        transition: 0.3s;
                        transform: translateX(50px);

                        &.animate {
                            opacity: 1;
                            transition: 0.3s;
                            transform: translateX(0px);
                        }
                    }
                }

                .close {
                    display: none;

                    img {
                        height: 18px;
                        width: 18px;
                    }

                    @media (max-width: 991px) {
                        display: block;
                    }
                    position: absolute;
                    right: 0;
                    top: -40px;
                    z-index: 100;
                    cursor: pointer;
                    opacity: 1;
                }

                @media (max-width: 991px) {
                    padding: 18px;
                    background: #f7f9fc;
                    border-radius: 8px;
                    width: 500px;
                    max-width: calc(100% - 30px);
                }

                .form-title {
                    font-weight: 600;
                    font-size: 22px;
                    color: #2c2c4f;
                    margin-bottom: 20px;

                    a {
                        font-size: 14px;
                        text-decoration: underline;
                        color: #0676c2;
                        line-height: 22px;
                        font-weight: normal;
                    }
                }

                .field {
                    width: calc(50% - 10px);
                    min-width: calc(50% - 10px);
                    @media (max-width: 991px) {
                        width: 100%;
                    }

                    &.street_name,
                    &.city {
                        width: calc(70% - 10px);
                        min-width: calc(70% - 10px);
                    }

                    &.street_number,
                    &.zip {
                        width: calc(30% - 10px);
                        min-width: calc(30% - 10px);
                    }

                    input {
                        background: #ffffff;
                        border: 1px solid #e2e9f2;
                        box-sizing: border-box;
                        border-radius: 50px;
                        height: 56px;
                        padding: 0px 20px;
                        margin-bottom: 20px;
                        display: block;
                        width: 100%;
                        outline: none;

                        &.error {
                            border-color: #f00;
                            animation: shake 0.82s
                                cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                        }
                    }

                    a {
                        font-size: 14px;
                        text-decoration: underline;
                        color: #0676c2;
                        margin-left: 20px;
                    }

                    .btn {
                        background: #1eb26d;
                        border-radius: 50px;
                        height: 56px;
                        width: 100%;
                        border: none;
                        outline: none !important;
                        font-weight: 600;
                        font-size: 18px;
                        color: #ffffff;
                        margin-bottom: 8px;
                        box-shadow: none !important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
            
                        img {
                            margin-left: 10px;
                        }
            
                        &:hover,
                        &:active {
                            background: darken(#1eb26d, 5%);
                        }
                    }
                }
            }
        }
    }
}

@keyframes shake {
    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}
</style>
